module.exports = "/assets/data/2eb7500a66a63bf633a347c01b1175b0-GU18.data.json";